import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { customerActions } from "stores/customer/customerActions";
import { commonActions } from "stores/common/commonActions";
import { jarvisPrimeOnboardingActions } from "stores/jarvisPrime/jarvisPrimeOnboarding/jarvisPrimeOnboardingActions";

const mapStateToProps = (state) => ({
  currentStagePrime: state.jarvisPrime.primeOnboarding.currentStagePrime,
  isOnboardingDataFetched: state.jarvisPrime.primeOnboarding.isInitialFetched,
  isOnboardingDataLoading:
    state.jarvisPrime.primeOnboarding.loading.primeOnboardingData,
  emailId: state.customer.loginProfile.email,
  name: state.customer.loginProfile.name,
  isEmailVerified: state.customer.loginProfile.isEmailVerified,
  isPrimeOnboardingCompleted:
    state.jarvisPrime.primeOnboarding.isPrimeOnboardingCompleted,
  isRMSOnboardingCompleted: state.jarvisRMS.rmsOnboarding.isOnboardingCompleted,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getOnboardingDataAction: jarvisPrimeOnboardingActions.getOnboardingData,
      getProfileAction: customerActions.getProfile,
      logoutAction: customerActions.logout,
      setToast: commonActions.setToast,
      updateEmailAction: customerActions.updateEmail,
    },
    dispatch,
  );

const OnboardingLayoutPrimeStore = (Component) =>
  connect(mapStateToProps, mapDispatchToProps)(Component);

export default OnboardingLayoutPrimeStore;
